<!--
     <ConfirmDialog
       ref='confirm_dialog'
     />

     Public methods:
       lauch() → Async method that returns the boolean answer

     Example:
       const good_day = await this.$refs.confirm_dialog.launch({
         title: 'Good day',
         text: 'Is today a good day?',
         yes: "yes",
         no: "Nope"
         yes_last: true
       })
-->

<template>
  <v-dialog
    v-model="confirm_dialog_model"
    width="600px"
  >
    <v-card class="elevated-1">
      <v-card-title class="text-h5 grey lighten-2">
        {{ title }}
      </v-card-title>

      <v-card-text class="pt-4">
        {{ text }}
      </v-card-text>

      <v-divider></v-divider>

      <div style="display: flex; flex-direction: row; justify-content: space-between; padding: 8px">
        <v-btn color="primary" text @click="confirm_resolve(!yes_last)">
          {{ yes_last ? no : yes }}
        </v-btn>
        <v-btn color="primary" @click="confirm_resolve(yes_last)">
          {{ yes_last ? yes : no }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>


<script>
 export default {
   name: "ConfirmDialog",

   data: () => ({
     confirm_dialog_model: false,
     confirm_resolve: () => {},
     title: '',
     text: '',
     yes: 'Yes',
     no: 'No',
     yes_last: true,
   }),

   methods: {
     launch({title='', text='', yes=this.$vuetify.lang.translator('confirm'), no=this.$vuetify.lang.translator('denny'), yes_last=true} = {}) {
       this.title    = title;
       this.text     = text;
       this.yes      = yes;
       this.no       = no;
       this.yes_last = yes_last;

       this.confirm_dialog_model = true;

       return new Promise(resolve => {
         this.confirm_resolve = resolve;
       }).then(ok => {
         this.confirm_dialog_model = false;
         return ok;
       });
     }
   },
 }
</script>
